module.exports = __webpack_public_path__ + "static/technologies.4b16c209.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/technologies.jpg
// module id = 838
// module chunks = 77045900137884